export type Lang = typeof enUS;

const enUS = {
  logoAlt: 'Passportcard logo',
  title: 'PassportCard AU',
  accessibilityStatement: 'Accessibility Statement',
  recaptchaStatement: "The site is secured using reCAPTCHA subject to Google's privacy policy and terms of use",
  tripDetailsDisclaimer:
    'PassportCard Australia Pty Ltd (PassportCard) ABN 76 621 476 220 (AFSL 551 057) is an Underwriting Agency acting under Binder from Guild Insurance Limited (Guild) ABN 55 004 538 863 (AFSL 233 791). Any advice provided by PassportCard in relation to PassportCard products and the PassportCard is general advice only. Please consider the Combined Financial Services Guide & Product Disclosure Statement and the PassportCard Terms and Conditions (available at <a href="https://www.passportcard.com.au"> https://www.passportcard.com.au/</a>) before deciding whether they are suitable for you.',

  edit: 'Edit',
  cancel: 'Cancel',
  add: 'Add',
  added: 'Added',
  save: 'Save',
  update: 'Update',
  completed: 'Completed',
  loading: 'Loading...',
  close: 'Close',
  age: 'Age',
  traveler: 'Traveller',
  question: 'Question',
  included: 'Included',
  continue: 'Continue',
  acceptAndContinue: 'Accept & Continue',
  back: {
    mobile: 'Back',
    desktop: 'Previous'
  },
  forms: {
    age: 'Age',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email address',
    date: 'Date of birth',
    countryCode: 'Country',
    phone: 'Mobile',
    phonePlaceholder: 'E.g. 0402 123 456',
    noResult: 'Cannot be found'
  },
  validatorsError: {
    required: 'Required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    name: 'Please enter a valid name',
    id: 'Please enter a valid id number',
    dateError: 'Please enter a valid date',
    idDuplication: 'ID number is already associated with another traveller',
    nonRequired0To9999: 'You cannot set a broker fee higher than $9999.99',
    postcode: 'Invalid postcode',
    duplicatedEmail: 'Email is already associated with another traveller',
    duplicatedPhone: 'Phone number is already associated with another traveller',
    lettersOnly: 'Only letters allowed'
  },
  quoteOverview: {
    medicalQuestionnaireFooterNotice:
      'We have added coverage for your existing condition based on the answers provided in the medical questionnaire.',
    currencyNotice:
      'Charges will be made in Shekels according to the representative exchange rate on the policy issuance date.',
    discountNotice:
      'The price includes a 15% discount on the selected extensions (except for the basic policy and search and rescue extensions).',
    policyContentsHeader: 'Policy Contents',
    yourQuote: 'Your Quote',

    totalLabel: 'Total',
    paymentAmountDescription: 'Show details about payment amount.',
    includedLabel: 'Included',
    travelersCountLabel: {
      multiple: 'Travellers',
      single: 'One Traveller'
    },
    destinationAltPrefix: 'Selected destination ',
    destinationsToggleOptions: {
      more: 'more destinations...',
      less: 'Show less'
    },
    brokerFee: {
      brokerFeeTitle: 'Broker Fee',
      brokerFeeSubtitle: 'Broker fee amount',
      brokerFeePlaceholder: '$ Enter fee (Excluding GST)',
      brokerFeeButton: 'Update Broker Fee'
    },
    emailQuote: {
      emailQuoteTitle: 'Email Your Quote',
      emailQuoteSubtitle: `We’ll email your quote to you.<br>Please see our <a href="{{url}}"  target="_blank" id="privacyPolicy">Privacy Policy.</a>`,
      emailQuoteInputLabel: 'Your Email',
      emailQuoteAlertTitle: 'Your quote has been emailed',
      emailQuoteAlertSubTitle: 'It should appear in your inbox within a couple of minutes.',
      emailQuoteButton: 'Email Quote'
    },
    selectedCovers: {
      basicCovers: 'Basic Covers',
      optionalCovers: 'Optional Cover(s)',
      activityCovers: 'Activity Cover(s)',
      yourCover: 'Your Cover',
      additionalCovers: 'Additional Components',
      basePackage: 'Base Package',
      yearlyBasePackage: 'Yearly Package',
      baseCoverageNotice:
        'The base package includes coverage for search and rescue, and third-party liability, unless you chose to remove them'
    }
  },
  /******************************* Popups Translations *******************************/
  /***********************************************************************************/
  deleteTravelerPopup: {
    title: 'Are you sure you want to delete {{firstName}} {{surName}}?',
    deleteButton: 'Yes - Delete',
    imgAlt: 'Passportcard Image'
  },
  programmaticallyAddedCoverPopup: {
    title: `We've added Traveller 2 to your selected Activity Covers`,
    information: `We've automatically added Traveller 2 to the Activity Covers that you've selected. You can remove Traveller 2 by clicking 'Details' on the Activity Cover and unselecting them.`,
    button: `Close`,
    imgAlt: `activity_cover_added_popup`
  },
  quotePriceChangePopup: {
    title: 'Why has the price dropped',
    info: `Your {{productName}} quote includes cancellation cover from the date you completed your quote.

Now you’re closer to your departure date, the cost has reduced as it includes less days of pre-trip cancellation coverage and you’ll see this reflected in the new price.`
  },
  getInTouchPopup: {
    title: {
      ageRestriction: 'Please get in touch',
      generalError: `Oops something went wrong`
    },
    imgAlt: 'get_in_touch',
    information: {
      ageRestriction: `Due to the age you've entered we are not able to provide you with a quote online. Please get in touch with our Sydney-based team or complete the form below and a representative will be in touch within 1 business day.`,
      generalError: `Unfortunately, the process could not be completed. Call us for help or complete the form below and our team will phone you back.`
    },
    phoneNumber: '1300 123 413',
    phoneNumberAgent: '1300 123 414',
    submitButton: 'Get in touch',
    success: {
      title: 'Thank you for submitting your details, a representative will be in touch.',
      button: 'Close'
    }
  },
  ReferralPopup: {
    titleDefault: 'We need to speak with you',
    titleActivePolicy: 'A policy already exists for these dates',
    titleCardError: 'Your payment has failed',
    titleCommonErrorPolicy: 'Oops something went wrong',
    titleAfterConfirmation: 'We’ll call you back',

    textInformation: 'Based on the information provided, we need to talk to you to complete your medical assessment',
    textActivePolicy: 'If you need to extend or change the dates of your policy, please call us.',
    textInformationCommonErrorPolicy: 'Unfortunately, the process could not be completed.',
    textCardError: 'Please try again or call us.',
    textInformationAfterConfirmation: 'You’re almost there!',
    textSubInformation:
      'One of our Sydney-based representatives will be in contact with you within 1 business day or you can call us using the number below.',
    textSubInformationAfterConfirmation: 'Thank you for submitting your details. Someone will be in touch soon. ',
    buttonText: 'Summary of Cover',
    buttonTextAfterConfirmation: 'Close',
    secondaryButtonText: '<a href=tel:{{noSpacePhone}}>{{phone}}</a> '
  },
  preExCharge: {
    title: `Medical Premium`,
    description:
      'We have reviewed your answers to our Health Screening and added an additional premium to your quote based on your responses.\n\nMedical Premium {{price}}'
  },

  /****************************** Steps Translations *****************************/
  /*******************************************************************************/
  whoIsTravelling: {
    title: 'Who is travelling?',
    subtitle: 'List all travellers ages at time of travel',
    alertTitle: 'Live in separate households?',
    alertDescription: 'You may want individual polices so you both have your own PassportCard',
    addAdultTraveller: 'Add Adult',
    addChildTraveller: 'Add Children / Dependants',
    adultsToolTip: {
      title: 'Adults',
      tooltipText:
        'Your policy must have an adult aged 18 or older at the time of travel.<br>You can have up to {{maxAdults}} adults on the policy.<br>* All fields are mandatory.'
    },
    childrenTooltip: {
      title: 'Children / Dependants',
      tooltipText:
        'Children/Dependant means an Insured Person’s unmarried children (including step or legally adopted children) who are: (a) under 19 years of age; or (b) under 25 years of age and full-time students at an accredited institution of higher learning'
    },
    newTravelerCard: {
      ageLabel: 'Age at time of travel',
      stateLabel: 'Which state do you live in?',
      errors: {
        required: 'Required',
        adult: 'Please add as Child/Dependant',
        child: 'Please add as Adult',
        invalid: 'Invalid age'
      }
    }
  },
  calendar: {
    pickDestinationDateForScreenReader: 'Departure date picked, please pick destination date.',
    finishPickedForScreenReader: 'Return date picked, please move to the next step button by pressing tab.',
    travelPeriodPlaceholderText: 'Entire Travel Range',
    travelPeriodEditText: 'Range Selection',
    editBtnText: 'Edit',
    todayCellText: '',
    errorMsg: 'There is an error in selecting the dates'
  },
  tripDates: {
    title: 'When are you travelling?',
    dateSelectionDepartureHeader: 'Select departure date',
    dateSelectionReturnHeader: 'Select return date',
    yearlyPolicydateSelectionHeader: 'Policy start date',
    dateSelectionDepartureSubHeader: '',
    dateSelectionReturnSubHeader: '',
    yearlyPolicySubHeader: '',
    summaryDays: '{{count}} days',
    summaryDay: 'One day',
    greatTimeAway: 'Includes your departure and return days',
    editNote: 'You can edit the values ​​by clicking "Edit"',
    fromDate: 'Departure',
    toDate: 'Return',
    editFromDate: 'Edit from date',
    editToDate: 'Edit to date',
    shortTerm: 'Daily policy',
    yearlyPolicy: 'Yearly policy',
    yearlyPolicyYellowCardText:
      'The policy end date is automatically calculated for 365 days. Please note - up to 30 days in a row for each trip with no limit on the number of trips.',
    errorPopUpHeader: 'Please note',
    annualTravelerCountExceeded:
      'The travellers composition is not suitable for this policy. In the annual plan, one insured can be updated in each policy.',
    annualTravelerAgeExceeded:
      'Annual policy is not suitable for ages 70 and above. One or more of the travellers exceeds the age limit.',
    noProductsAvailable: 'Based on the information provided, we cannot continue with the purchase.',
    errorPopUpButtonText: 'Update passengers list',
    errorPopUpAlternativeLinkText: 'Switch to daily policy'
  },
  whereAreYouTraveling: {
    title: 'Where are you travelling?',
    subtitle: 'Search for a destination',
    destinations: 'Popular destinations',
    autocompletePlaceholder: 'Search...',
    autocompleteErrorMsg: `Unfortunately we are unable to provide cover for this country. Please remove it from your quote to continue or call us on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a> to discuss`,
    addDestination: 'Add destination',
    removeDestinationAria: 'Remove destination {{country}}',
    guidanceTitle: 'Important Information',
    pickedTitle: 'I’m travelling to',
    stopGuidance:
      "No need to select Australia if you're going overseas, your international policy covers it (limits apply). Stopovers under 48 hours are also automatically included.",
    mixedDestinationsTitle: "Travelling overseas and within Australia? You're covered",
    mixedDestinationsWarning:
      'When you are travelling both domestically and internationally on a trip, you are covered under your international policy (Limits apply).\n' +
      'We’ve removed Australia from your Destination selection but don’t worry, you’re covered from the time you leave home.'
  },
  gateway: {
    title: 'Insure Your Trip Your Way',
    subtitle:
      'We’re giving you the flexibility to choose the cover that best suits your needs – everything included or just what you need.',
    choosePlanDesktop: `Please choose a product below:`,
    choosePlanMobile: `Choose the cover that’s right for you`,
    includes: 'Includes',
    more: 'And much more',
    back: 'Edit Trip Details',
    comprehensive: {
      title: 'Comprehensive',
      subtitle: 'Our Comprehensive cover has the broadest protection for your next adventure.',
      buttonText: `Get a Quote`
    },
    flexiCover: {
      title: 'Flexi Cover',
      subtitle: `Tailor your own cover – choose only what you need, nothing you don’t.`,
      customiseText: 'Customise your cover with add-ons:',
      buttonText: `Tailor Your Quote`
    }
  },
  covers: {
    priceDetail: 'per day passenger',
    leaveCaption: 'Leave',
    removeCaption: 'Remove',
    popUpButton: 'Details',
    title: 'The basic cover package',
    price: 'Price',
    subTitle: 'Our basic insurance package includes four covers',
    itemsCounterLabel: 'Items',
    itemsCounterSingleLabel: 'One item',
    itemsSelectionLimitSubTitle:
      'You can select up toThe amount of items to cover is limited by the number of passengers',
    startDateAlt: 'Cover start date',
    endDateAlt: 'Cover end date',
    pdsLink: `See the <a href="{{pdsLink}}" target="_blank" id="pdsLink">PDS</a> for full details.`,
    basicCard: {
      title: 'The base components',
      details:
        'The basic insurance components that will ensure a responsible trip. Includes third party liability coverage and locating, search and rescue. These components can be changed by clicking the Detail button.',
      subCardTitle: 'The base components',
      subCardDetails:
        'The basic insurance components that will ensure a responsible trip. Includes third party liability coverage and locating, search and rescue. These components can be changed by clicking the Detail button.',
      continueNextStep: 'Continue to next step, Additional covers'
    },
    coverLimits: {
      coverLimitTitle: 'Trip Cancellation Cover',
      coverLimitDescription:
        'Choose an amount to cover you for pre-paid expenses if you cancel or change your trip due to unforeseen circumstances, before leaving home.',
      coverLimitPlaceholder: 'Cover Limit',
      coverLimitLabel: 'Select a limit to cover your trip cancellation costs',
      excessAmountTitle: 'Set your Excess amount',
      excessAmountDescription:
        'Overseas medical claims, delayed luggage or theft of cash never attract an excess. The excess amount you choose applies only to the remaining sections of cover.',
      excessAmountPlaceholder: 'Excess Amount',
      excessLabel: 'Set your excess amount'
    },
    valuableItems: {
      headerTitle: 'Which items would you like to add?',
      title: 'Valuable items',
      description:
        'Coverage of up to $2,000 for theft of items from the list below. Covers can be purchased according to the number of passengers.',
      coverItemPricePerDayLabel: 'Day price per device:',
      valuableItemCoverPricePerDayLabel: 'Day price per item:',
      incrementAriaLabel: 'Increment unit',
      decrementAriaLabel: 'Decrement unit',
      itemSelectedArialLabel: 'Item selected {{item}}'
    }
  },
  optionalCovers: {
    add: 'Add',
    added: 'Added',
    title: 'Optional Covers',
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  activityCovers: {
    add: 'Add',
    added: 'Added',
    title: 'Activity Covers',
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  comprehensiveCovers: {
    title: 'Comprehensive Cover',
    subtitle: 'Our Comprehensive Cover Includes',
    excess: `Customise Your Excess`,
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details'
  },
  byoCovers: {
    title: 'Build Your Own Cover',
    subtitle: 'Would you like to add any of the following covers to your policy?',
    disclaimer: `(We'll need you to answer either yes or no)`,
    excess: `Choose Your Excess`,
    buttonAriaLabel: 'Details',
    buttonTitle: 'Details',
    Added: 'Cover Added',
    dependantTitle: 'Travelling with phone, laptop or camera over $1,500?',
    additionalItems: 'Additional Items',
    additionalItemsSubTitle:
      'Increase your luggage item limit for selected valuable items that are valued above the limits '
  },
  travelerDetails: {
    title: 'Traveller Details',
    allInputsRequiredSubtitle:
      'All fields are mandatory. Unique mobile & email allows Traveller 2 to get travel alerts',
    inputsRequiredSubtitle: 'All fields are mandatory',
    dobAndAgeMismatchTitle: "Oops... the entered age and date of birth don't match",
    dobAndAgeMismatchMessage:
      'The age entered doesn’t match the traveller’s date of birth at the time of travel. No worries, we’ll update your quote to reflect this change.',
    adultDOBErrorTitle: 'An Adult DOB is under 18',
    adultDOBErrorMessage:
      "You’ve entered a date of birth that is under 18 and we cannot insure you as an adult online, please call us on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a and our customer team can help you",
    ageExceptionTitle: 'Age entered is over 85',
    ageExceptionMessage:
      "Due to the age you've entered we are not able to provide you with a quote online. Please get in touch with our Australia-based team on <a href=tel:1300-123-413 class='phone-link'>1300 123 413</a> and they can help you.",
    childDOBErrorTitle: 'A child DOB is over 25',
    childDOBErrorMessage:
      ' The date of birth entered for your child/dependant is over the age of 25 and they are required to be an adult on a policy. Please go back to Trip Details and update your quote',
    countryLabel: 'Country',
    countryNoResult: 'No results found',
    mobileLabel: 'Mobile',
    ageLabel: 'Age',
    save: 'Save Traveller',
    saveAndContinue: 'Save & Move to Next Traveller',
    update: 'Update',
    calendarNoteTitle: 'Already left?',
    calendarNoteMessage: "If you've already started your trip, this cover is subject to a 3-day no cover period."
  },
  healthDeclaration: {
    healthScreening: {
      title: 'Health Screening',
      subtitle: 'Please answer the following questions for all travellers',
      checkboxesText: 'Please select all travellers affected by this condition',
      accpetanceCriteria1:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.',
      accpetanceCriteria2:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.'
    },
    medicalAssessment: {
      title: 'Medical Assessment',
      subtitle: 'Please answer the following questions for each listed traveller below',
      accpetanceCriteria1:
        'Based on the information provided, all travellers are covered for their pre-existing health conditions.',
      accpetanceCriteria2:
        'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately.'
    },
    title: 'Health Screening',
    subtitle: 'Please answer the following questions for all travellers.',
    text: 'We will automatically cover you for many pre-existing health conditions but we need you to answer the following questions. For some more serious or recent health conditions, we may need to ask you a few more questions to make sure you have the right cover for your trip.',
    agreement:
      "I agree to the <a href='#' id='candidateStatement'>candidate statement</a> and confirm that I have read and understood the <a href='#' id='termsAndConditions'>terms of use</a> and <a href='#' id='privacyPolicy'>privacy policy</a> through the website.",
    choiceQuestionLabel: 'Pick answer to question: {{question}}',
    questionAssessment:
      'We have a few more questions for you to complete as part of the Medical Assessment to make sure you are covered, and in some cases we may need to talk to you but we will let you know and will contact you within 1 business day.',
    questionAssessmentTitle: 'Medical Assessment',
    footerText1:
      'Based on the information provided, all travellers are covered for their \n' +
      'pre-existing health conditions.\n' +
      'Details cannot be edited after submission and proceeding to the next step.',
    footerText2:
      'I confirm that I understand my Duty to take reasonable care not to make a misrepresentation and I have answered all questions honestly and accurately. Details cannot be edited after submission.'
  },
  deliveryAddress: {
    title: 'Delivery Address',
    addressPickingTexts: {
      title: 'Where should we send your PassportCard?',
      deliveryAddressInputLabel: 'Delivery Address',
      billingAddressInputLabel: 'Billing Address',
      addressInputNoResult: 'No Result',
      addressInputPlaceholder: 'Enter Address',
      manualAddressText: "Can't find your address? Add manually",
      automaticAddressText: 'Return to previous address format',
      cityInputLabel: 'City',
      cityInputPlaceholder: 'Enter city',
      streetInputLabel: 'Street Address',
      streetInputPlaceholder: 'Enter Address',
      stateInputLabel: 'State',
      stateInputPlaceholder: 'Enter state',
      postcodeInputLabel: 'Postcode',
      postcodeInputPlaceholder: 'E.g. 1234'
    },
    billingAddressText: 'My billing address is the same as my delivery address',
    billingToggleTexts: {
      yes: 'Yes',
      no: 'No'
    },
    alertTitle: 'Why do I need a delivery address?',
    alertSubTitle: `Your physical PassportCard will be delivered to your address. Don't worry you're still covered without the card.`
  },
  formDeclarations: {
    section1: `All travellers are Australian Citizens or hold valid visas to live, work or study in Australia and intend to return to Australia during the period of insurance.`,
    section2: `I confirm that I have read and understood the Combined <a href="{{pdsLink}}" target="_blank" id="fsgAndPds" class="link-text">FSG and PDS</a> and <a href="{{travelAlertsLink}}" target="_blank" id="travelAlerts" class="link-text">Travel Alerts</a>. I confirm that I understand my <a href="{{dutyOfDisclosureLink}}" target="_blank" id="dutyOfDisclosure" class="link-text">Duty to take reasonable care</a> not to make a misrepresentation and I have answered all questions honestly and accurately. I confirm that I have read, understand and agree to the terms of the <a href="{{privacyNoticeLink}}" target="_blank" id="privacyNotice" class="link-text">Privacy - Collection Statement </a> and the <a href="{{privacyPolicyLink}}" target="_blank" id="privacyPolicy" class="link-text">Privacy Policy</a>. Where I have provided personal information about any other person I have their consent to do so.`,
    section3: `I consent to receiving marketing information about other PassportCard products and services. I acknowledge I can opt out at any time (optional).`,
    disclaimer: `The PassportCard is subject to its own <a href="{{termsAndConditionsLink}}" target="_blank" id="termsAndConditions" class="link-text">Terms and Conditions</a>. In the event of an approved claim you do not have to use the PassportCard if you prefer to pay for any expenses yourself and be reimbursed later.`
  },
  secureCheckout: {
    title: 'Secure Checkout',
    paymentRulesTitle: 'Purchase with peace-of-mind',
    paymentRules: {
      offPeriod: '21 day cooling off period',
      daysOfWeekSupport: '24/7 Global Customer Support',
      cardInform: '2 million card holders worldwide',
      someInfo: 'Canstar winning travel insurance'
    },
    cardsLogosAlt: 'Visa, Master Card, American Express, Apple Pay, Google Pay logos',
    paymentDisclaimer:
      'Your payment and personal details are stored securely. For more information please read our Privacy Policy.'
  },
  SuccessScreen: {
    confirmationTitle: 'You’re all insured!',
    confirmationSubtitle: 'On behalf of the PassportCard crew, we hope you have a pleasant trip.',
    policyNumberLabel: 'Policy Number',
    summaryOfCover: 'Summary of Cover',
    footerNotice: 'Your policy details have been sent to your email and mobile phone.',
    totalPrice: 'Total Price',
    newPolicy: 'Purchase new policy'
  },

  /********************************* Aria Labels *********************************/
  /*******************************************************************************/
  backStepAriaLabel: 'Back to previous step',
  closePopUpAriaLabel: 'Close Popup Dialog {{popupTitle}}',
  addCoverToTravelerAriaLabel: 'Add cover {{coverName}} for {{travelerName}}',
  editCoverToTravelerAriaLabel: 'Edit cover for {{travelerName}}',
  addTravelerAriaLabel: 'Add traveller {{travelerName}}',
  editTravelerAriaLabel: 'Edit details of traveler {{travelerName}}',
  removeTravelerAriaLabel: 'Remove Traveller {{travelerName}}',
  continueAndSave: 'Save and continue to the next question',
  continueToOTPStep: 'Continue to the next step, type the sms you received',
  continueTripDestStep: 'Continue to the next step, Trip Destination.',
  continueTripDatesStep: 'Continue to the next step, Trip Dates.',
  continueTripDetailsStep: 'Continue to the next step, Trip Details.',
  continueBasicCoversStep: 'Continue to the next step, Basic Covers',
  continueHealthDeclarationStep: 'Continue to the next step, Health Declaration',
  continueNextQuestion: 'Continue to next question',

  //********************************************************************************************************************************************************/
  //********************************************************************************************************************************************************/
  errorGuardianAge: 'The guardian must be at least 18 years old',
  errorIncorrectAdults:
    'Note! Adding a traveller who is not part of your family composition. You cannot select more than two adults on the policy. For an additional adult, you must purchase a separate policy',

  continuePurchase: 'Continue purchase',
  brokerPopupText: 'The property is transferred to the purchase of travel insurance PassportCard through brokers',
  newOrExistingCustomerQuestion: 'Have you already purchased a passport card before?',
  newOrExistingCustomerText:
    'If you have previously purchased a travel policy abroad with us, we can help you faster..',
  newCustomerAnswer: 'Yes',
  existingCustomerAnswer: 'No',
  newCustomerText: 'This is the first time',
  existingCustomerText: 'I have purchased from you before',
  chooseAtLeastOneTraveler: 'Please select traveller',
  chooseAtLeastCarType: 'Please select car type',
  otpTitle: 'We sent you an SMS code',
  otpQuestion: 'What is the code you received? (6 digits)',
  otpGuidance: 'The code has been sent to a phone that ends with - ',
  otpSendAgain: 'Send again',
  otpErrorMessage: 'The code you entered is invalid',
  otpRememberMe: 'Remember me for 24 hours',
  idTitle: 'We would be happy to identify you',
  idQuestion: 'ID number',
  idQuestionAriaLabel: 'Enter ID Number, after filling ID number it will be automatically updated.',
  continueWithoutIdAriaLabel: 'Button to continue without identification',
  resendSMSAriaLabel: 'Button to send a new SMS',
  continueWithoutId: 'Continue without identification',
  idErrorMessage: 'We could not find your ID number',
  customer: {
    newOrExistingCustomerQuestion: 'Have you already purchased a passport card?',
    newOrExistingCustomerText:
      'If you have previously purchased a travel policy abroad with us, we can help you faster..',
    newCustomerAnswer: 'No',
    existingCustomerAnswer: 'Yes',
    newCustomerText: 'This is the first time',
    existingCustomerText: 'I have purchased from you before',
    newCustomerTextAria: "No, I haven't purchased travel policy from Passportcard before",
    existingCustomerTextAria: 'Yes, I have purchased travel policy from Passportcard before',
    footerTextTitle: 'When can you not purchase insurance?',
    footerTextRule0: 'After you have already left Australia',
    footerTextRule1: 'If you intended to take off from another country',
    footerTextRule2: 'If the purpose of the trip is to receive treatment or medical advice abroad'
  },
  agentExistingPage: {
    title: 'Purchasing a policy on behalf of an agent',
    newOrExistingAgentQuestion: 'Has the customer made a purchase in the past? (Existing Customer)'
  }
};

export default enUS;
